<template lang="pug">
  vm-prompt(@vm-cancel="close" vm-color="danger" @vm-accept="saveRecord" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-active="isModalNoteVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("commissions.note_placeholder")' v-model="addNote.note" :label='$t("commissions.note")')
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Commissions')

export default {
  name: 'ModalCommissionsNote',
  props: {
    addNote: {
      type: Object,
      default: () => {}
    },
    isAdd: {
      default: true,
      type: Boolean
    }
  },
  data: () => ({
  }),
  validations: {
    addNote: {
      // contact: {
      //   required,
      //   minLength: minLength(5)
      // },
      // email: {
      //   required,
      //   email
      // }
    }
  },
  computed: {
    ...mapGetters([
      'isModalNoteVisible',
      'commissionsCatalog'
    ]),
    getTitle () {
      return 'Motivo del rechazo'
    }
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'actionCommission',
      'rejectCommissions',
      'setModalNoteVisible',
      'loadCatalog',
      'loadCommissions'
    ]),
    async saveRecord () {
      if (!this.addNote.isAll) {
        await this.actionCommission({ id: this.addNote.id, action: this.addNote.action, note: this.addNote.note }).then(() => {
          this.loadCommissions({ page: this.addNote.page, perPage: this.addNote.perPage })
          this.setModalNoteVisible(false)
        })
      } else {
        this.rejectCommissions({ ids: this.addNote.id, note: this.addNote.note }).then(() => {
          this.loadCommissions({ page: this.addNote.page, perPage: this.addNote.perPage })
          this.setModalNoteVisible(false)
        })
      }
    },
    async getCatalog () {
      Object.keys(this.commissionsCatalog).forEach(e => this.loadCatalog({ url: e, filter: '' }))
    },
    autoCompleteFunc (value) {
      let payload = {}
      let columns = value.target.parentElement.parentElement.getAttribute('columns')
      let param = value.srcElement.value
      payload.url = value.target.parentElement.parentElement.getAttribute('url')
      payload.filter = `?param=${param},${columns}`
      this.loadCatalog(payload)
    },
    close () {
      this.setModalNoteVisible(false)
    }
  }
}
</script>

<style lang="scss">
  .vm-table--tbody-table {
    min-width: 0 !important;
  }
  .vm-table--header {
    padding: 0 !important;
  }
</style>
